import {
  IAddress,
  IClinicalSettings,
  ICompanyProfile,
  IDefinAttachmentTemplate,
  IPrintingSettings,
  EPrintModel, IDPAModel, ILuxcreoModel, IStandardModel, PrintModelType 
} from "../app/slices/user/user.type"

import Deserialize from "./interface/Deserialize"
import { IUser } from "./interface"

export default class User implements IUser, Deserialize {
  id = ""
  firstName = ""
  lastName = ""
  address = ""
  city = ""
  state = ""
  zipCode = ""
  email = ""
  phoneNumber = ""

  Deserialize(input: any): this {
    if (input) {
      if (input.id) {
        this.id = input.id
      }
      this.firstName = input.firstName
      this.lastName = input.lastName
      this.address = input.address
      this.city = input.city
      this.state = input.state
      this.zipCode = input.zipCode
      this.email = input.email
      this.phoneNumber = input.phoneNumber
    }
    return this
  }
}

export class CompanyProfile implements ICompanyProfile, Deserialize {
  id: 0
  name: ""
  orgType: ""
  orgStatus: ""
  orgCreatedOn: ""
  activatedOn: ""
  licenseValidDate: ""
  billingMethod: ""
  invoiceStartDate: ""
  address: IAddress[]
  accountOwner: ""
  clinicalEdSpec: ""

  Deserialize(input: any): this {
    if (input) {
      if (input.id) {
        this.id = input.id
      }
      this.name = input?.name
      this.orgType = input?.org_type
      this.orgStatus = input?.org_status
      this.orgCreatedOn = input?.org_created_on
      this.activatedOn = input?.activated_on
      this.invoiceStartDate = input?.invoice_start_date
      this.licenseValidDate = input?.licensevaliddate
      this.billingMethod = input?.billing_method
      this.accountOwner = input?.account_owner
      this.clinicalEdSpec = input?.clinical_ed_spec

      const updatedAddresses: IAddress[] = []
      input?.address?.map((eachAddress) => {
        const address: IAddress = {
          line_1: eachAddress?.line_1,
          line_2: eachAddress?.line_2,
          city: eachAddress?.city,
          state: eachAddress?.state,
          regionName: eachAddress?.region_name,
          countryName: eachAddress?.country_name,
          zipCode: eachAddress?.zip_code,
          email: eachAddress?.email,
          phone: eachAddress?.phone,
          type: eachAddress?.type,
        }
        updatedAddresses.push(address)
      })
      this.address = updatedAddresses
    }
    return this
  }
}

export class ClinicalSettings implements IClinicalSettings, Deserialize {
  CuttingLineCP: number
  NumberSystem: string
  CuttingLineCC: number
  CuttingLineOffset: number
  AttachmentStage: number
  stage_number?: string
  toothLabel?: string[]
  LabelStagingNumber?: string
  LabelStagingNumberStart?: string
  StageNumberLeftOrRight?: boolean
  UnderCut?: number
  UseuContourMachine?: number
  LabelLocation?: string
  CaseTag?: number[]
  DefinAttachmentTemplate?: IDefinAttachmentTemplate[]
  GenerateShell?: number
  DrainHole?: number
  ShellThickness?: number
  PrintDirection?: number
  HeightOfWall?: number
  DefaultStep_angle?: number
  DefaultStep_length?: number
  PrintSetting?: IPrintingSettings
  PrintDefaultModel?: PrintModelType
  StandardModel?: IStandardModel
  DPAModel?: IDPAModel
  LuxcreoModel?: ILuxcreoModel
  Deserialize(input: any): this {
    if (input) {
      this.CuttingLineCP = input.CuttingLineCP || 0
      this.NumberSystem = input.NumberSystem || ""
      this.CuttingLineCC = input.CuttingLineCC || 0
      this.CuttingLineOffset = input.CuttingLineOffset || 0
      this.AttachmentStage = input.AttachmentStage || 0
      this.stage_number = input.stage_number
      this.toothLabel = input.toothLabel
      this.LabelStagingNumber = input.LabelStagingNumber
      this.LabelStagingNumberStart = input.LabelStagingNumberStart
      this.StageNumberLeftOrRight = input.StageNumberLeftOrRight
      this.UnderCut = input.UnderCut
      this.UseuContourMachine = input.UseuContourMachine
      this.LabelLocation = input.LabelLocation
      this.CaseTag = input.CaseTag
      this.DefinAttachmentTemplate = input.DefinAttachmentTemplate
      this.GenerateShell = input.GenerateShell
      this.DrainHole = input.DrainHole
      this.ShellThickness = input.ShellThickness
      this.PrintDirection = input.PrintDirection
      this.HeightOfWall = input.HeightOfWall
      this.DefaultStep_angle = input.DefaultStep_angle
      this.DefaultStep_length = input.DefaultStep_length
      // PrintSetting
      const defaultModel = input?.PrintDefaultModel? (input?.PrintDefaultModel === EPrintModel.StandardModel ? EPrintModel.StandardModel : input?.PrintDefaultModel === EPrintModel.DPAModel ? EPrintModel.DPAModel : EPrintModel.LuxcreoModel) : undefined
      this.PrintSetting = {
        DefaultModel: defaultModel,
        StandardModel: input?.StandardModel || {},
        DpaModel: input?.DPAModel || {},
        LuxcreoModel: input?.LuxcreoModel || {},
      }
      this.PrintDefaultModel = input.PrintDefaultModel || PrintModelType.Standard
      this.StandardModel = input.StandardModel ? { ...input.StandardModel } : undefined
      this.DPAModel = input.DPAModel ? { ...input.DPAModel } : undefined
      this.LuxcreoModel = input.LuxcreoModel ? { ...input.LuxcreoModel } : undefined
    }
    return this
  }
}
